module.exports = __webpack_public_path__ + "img/tu05.766c739c.jpg";